import * as React from "react";
import { observer } from "mobx-react";
import { DeleteButton } from "../Buttons/DeleteButton";
import * as SettingsManagement from "../SettingsManagement";
import { InputFileComponent } from "../Inputs/InputFileComponent";

interface IFileUploadProps {
	item: SettingsManagement.BrandingDetail;
	handleChange: () => void;
	testId?: string;
	testName?: string;
}

@observer
export class FileUpload extends React.Component<IFileUploadProps, {}> {

	handleDelete = (e: React.MouseEvent<any, MouseEvent>) => {
		e.stopPropagation();
		this.props.item.file.value = "delete";
		this.props.item.file.previewUrl = null;
	}

	imageUploadClick = () => {
		this.refs.inputFileUpload.click();
	}


	refs: {
		[key: string]: InputFileComponent,
		inputFileUpload: InputFileComponent
	}

	render() {
		return <div onClick={this.imageUploadClick} className="imageupload brandingitem">
			<InputFileComponent ref="inputFileUpload" key={this.props.item.name} model={this.props.item.file} onChange={this.props.handleChange} testName={this.props.testName} testId={this.props.testId} />
			<span className="imageupload__tools">
				<div className="tinytool">
					<DeleteButton onClick={this.handleDelete} testName="deleteButton" />
				</div>
			</span>
		</div>;
	}
}


